import metaverse from './metaverse/routes';

export default [metaverse];
